import { render, staticRenderFns } from "./ZingChart.vue?vue&type=template&id=b26785ee&"
import script from "./ZingChart.vue?vue&type=script&lang=js&"
export * from "./ZingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports